<template>
  <el-dialog
      center
      :title="$t('routes.conditionsOfSaleTitle')"
      :visible.sync="splashScreenVisible"
      :before-close="refuseCgv"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      width="60%"
      v-if="!isUSH">
    <div>{{ $t("dashboard.cgvText") }}</div>
    <br />
    <div style="margin-left: 60px;">
      <ul>
        <li style="padding: 5px;"><a :href="'docs/conditions_generales_de_vente_de_diffusion_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfDiffusion") }}</a></li>
        <li style="padding: 5px;"><a :href="'docs/conditions_generales_de_vente_de_contact_manager_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfContactManager") }}</a></li>
        <li style="padding: 5px;"><a :href="'docs/conditions_generales_de_vente_de_social_manager_03_2025.pdf'" target="_blank" rel="noopener">{{ $t("layouts.conditionsOfSaleOfSocialManager") }}</a></li>
      </ul>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="refuseCgv">{{ $t("dashboard.refuse") }}</el-button>
        <el-button type="primary" @click="closeSplashScreen">{{ $t("dashboard.accept") }}</el-button>
      </span>
  </el-dialog>
</template>

<script>

import { updateUser } from '@/services/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogCgv',
  props: {
  },
  data () {
    return {
      splashScreenVisible: false
    }
  },
  components: {
  },
  computed: {
    ...mapGetters(['getUser']),
    isUSH () {
      return this.getUser.isUSH
    }
  },
  beforeMount () {
    if (!this.getUser.cgvValidated && !this.isUSH) {
      this.splashScreenVisible = true
    }
  },
  methods: {
    refuseCgv () {
      this.$router.push({ name: 'login', params: { signout: true } })
    },
    closeSplashScreen () {
      this.splashScreenVisible = false
      const user = this.getUser
      user.cgvValidated = true
      user.cgvVersion = '7'
      user.cgvValidatedDate = new Date()
      updateUser(user)
      this.$store.commit('setUser', user)
    }
  }
}
</script>
